export const DEFAULT_PROFILE = 'allstaff';
